import React, {useState} from 'react';
import WorkerJobTable from "../../../components/UI/table/orders/organization/workerJobTable/WorkerJobTable";
import {useParams} from "react-router-dom";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";

const WorkerJob = () => {
    const [alertData, setAlertData] = useState({});
    let params = useParams();
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    return (
        <div>
            <h4>Отметить работников выполнившех работу: {params.jobName}</h4>
            <h4>Материал: {params.jobMaterial}</h4>
            <WorkerJobTable id={params.id} handleModalAlert={handleModalAlert}/>
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </div>
    );
};

export default WorkerJob;